// import React, {useState, useEffect, useRef, useMemo, FC} from 'react'
// import { ConfigProvider } from '@bedrock/components';
// import { px2rem as Px2RemContext, initPx2Rem } from '@bedrock/utils';
// import { Lib as PxLib } from '@bedrock/utils/dist/types/px2rem';
// import classNames from 'classnames/bind'
// import styles from './index.less'

// const cx = classNames.bind(styles)

// const defaultRange = [
//   [[0, 1279], 0.6],
//   [[1279, 1439], 0.7],
//   [[1439, 1920], 1],
//   [[1920, 2560], 1.1],
//   [[2560], 1.5],
// ]

// const defaultBase = 2;

// const PxToRemWrapper: FC<any> = (props) => {
//   const [base, setBase] = useState(defaultBase);

//   useEffect(() => {
//     console.log('initPx2Rem')
//     initPx2Rem({
//       base: defaultBase,
//       setRemCallback: (v) => { console.log(v, 'setRemCallback'); setBase(v)  },
//       range: defaultRange,
//     } as PxLib);
//   }, []);

//   console.log(base, 'base')

//   return (
//     // props.children
//     <Px2RemContext.Provider
//       value={{
//         base: defaultBase,
//         remToPx: (value: number) => { console.log(value, 'remToPx'); return value * base },
//         viewBase: base / defaultBase,
//       }}
//     >
//       <ConfigProvider
//         ratio={base ? base / defaultBase : 1} // 设置组件内部的ratio，影响组件内部样式；
//       >
//       {props.children}
//       </ConfigProvider>
//     </Px2RemContext.Provider>
//   );
// };

// export default PxToRemWrapper;

import { defaultRootFontSize } from '#utils';
import { ProScreenAdapterProvider, useScreenAdapterContext } from '@bedrock/eed-react';  
import React, { FC, useState } from 'react';
import { ConfigProvider } from '@bedrock/components';
import { bedrockUtil } from '@bedrock/eed-react'
import { create } from 'zustand';

export const useScreenAdapter = create<any>(() => {
  return {
    viewBase: 1,
  }
})


const PxToRemWrapper: FC<any> = (props) => {
  const [viewBase, setViewBase] = useState(1);
  const { px2rem: Px2remContext } = bedrockUtil;

  // 切换 viewBase 时触发，需要给子应用中联动通信时使用
  const onViewBaseChange = (viewBase) => { setViewBase(viewBase) };

  return (
    <ProScreenAdapterProvider
      rootValue={defaultRootFontSize}
      // 屏幕宽度适配的缩放比例Map，默认如下可不传
      // range={[
      //   [[0, 1279], 0.6],
      //   [[1279, 1439], 0.7],
      //   [[1439, 1920], 1],
      //   [[1920, 2560], 1.1],
      //   [[2560], 1.5],
      // ]}
      // 存储到浏览器的 Key，不传默认为 RATIO_CONFIG，
      storageKey='RATIO_CONFIG'
      onViewBaseChange={onViewBaseChange}
    >
      <Px2remContext.Provider value={{ 
        base: 1,
        remToPx: (v) => v,
        viewBase,
       }}>
        <WithViewBaseConfigProvider>
        {props.children}
        </WithViewBaseConfigProvider>
      </Px2remContext.Provider>
      {/* <ConfigProvider
        ratio={viewBase} // 设置组件内部的ratio，影响组件内部样式；
      >
        {props.children}
      </ConfigProvider> */}
    </ProScreenAdapterProvider>
  );
}

export const WithViewBaseConfigProvider = (props) => {
  const screenAdapter = useScreenAdapterContext();

  useScreenAdapter.setState(screenAdapter)

  return (
    <ConfigProvider
      ratio={screenAdapter?.viewBase} // 设置组件内部的ratio，影响组件内部样式；
    >
      {props?.children}
    </ConfigProvider>
  )
}

export default PxToRemWrapper;
